import React, { useState, useEffect } from "react";
import { Button, Container, IconButton } from "@mui/material";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import { Link } from "react-router-dom";
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded";
import useMediaQuery from "@mui/material/useMediaQuery";
import { boilerMakes } from "../assets/data";
import fetchData from "../assets/data";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import axios from "axios";
import Cookies from "js-cookie";
import { API_BASE_URL } from "../components/Config";
import { useNavigate } from "react-router-dom";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const OneOffRepair = () => {
  const { id } = useParams();
  const [findMorcards, setFindMorCards] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [firstName, setFirstName] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [postcode, setPostCode] = useState("");
  const [address, setAddress] = useState("");
  const [make, setmake] = useState("");
  const [boiler_model, setboiler_model] = useState("");
  const [boiler_age, setboiler_age] = useState("");
  const [errorCode, setErrorCode] = useState("");

  const navigate = useNavigate();

  const simulateAPIRequest = async (url, method, data) => {
    try {
      const token = Cookies.get("token");
      const response = await axios({
        method,
        url,
        data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        enqueueSnackbar(error.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar("An error occurred", { variant: "error" });
      }
    }
  };
  const handleSubmit = async (e) => {
  e.preventDefault();

  const formData = new FormData(e.target);
  const data = Object.fromEntries(formData.entries());

  // Destructure fields from formData
  const {
    first_name,
    surname,
    email,
    phone_number,
    postcode,
    address,
    make,
    boiler_model,
    errorCode,
    boiler_age,
    plan_id,
  } = data;

  // Validate required fields
  if (
    !first_name?.trim() ||
    !surname?.trim() ||
    !email?.trim() ||
    !phone_number?.trim() ||
    !postcode?.trim() ||
    !address?.trim()
  ) {
    enqueueSnackbar("Please fill in all required fields", {
      variant: "error",
    });
    return;
  }

  const payload = {
    first_name: first_name.trim(),
    surname: surname.trim(),
    email: email.trim(),
    phone_number: phone_number.trim(),
    postcode: postcode.trim(),
    address: address.trim(),
    boiler_details: {
      make: make || null,
      boiler_model: boiler_model || null,
      boiler_age: boiler_age || null,
      errorCode: errorCode || null,
    },
    plan: plan_id,
  };

  try {
    const response = await fetch(`${API_BASE_URL}/plans/create-checkout-session/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (result.url) {
      enqueueSnackbar("Redirecting to payment...", { variant: "success" });
      window.location.href = result.url;
    } else {
      enqueueSnackbar("Failed to initiate payment", { variant: "error" });
    }
  } catch (err) {
    console.error("Checkout error:", err);
    enqueueSnackbar("An error occurred during checkout", { variant: "error" });
  }
}

  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value);
  };

  const handleSurnameChange = (e) => {
    setSurname(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePhoneNumberChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const handlePostCodeChange = (e) => {
    setPostCode(e.target.value);
    console.log(e.target.value, "eee");
  };

  const handleAddressChange = (e) => {
    setAddress(e.target.value);
  };

  const handleBoilermakeChange = (e) => {
    setmake(e.target.value);
  };

  const handleboiler_modelChange = (e) => {
    setboiler_model(e.target.value);
  };

  const handleboiler_ageChange = (e) => {
    setboiler_age(e.target.value);
  };

  const handleErrorCodeChange = (e) => {
    setErrorCode(e.target.value);
  };

  const [csrfToken, setCsrfToken] = useState("");
  const [user_id, setUserId] = useState("");
  useEffect(() => {
    const fetchCsrfToken = async () => {
      const token = Cookies.get("token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      try {
        console.log("fetching HEADER", headers);
        const response = await axios.get(`${API_BASE_URL}/plans/get-csrf/`, {
          headers: headers,
        });
        setCsrfToken(response.data.csrfToken);
        setUserId(response.data.user_id);
      } catch (error) {
        console.error("Error fetching CSRF token:", error);
      }
    };

    fetchCsrfToken();
  }, []);

  // const handleFindAddress = async () => {
  //   console.log(postcode, "postcodepostcodepostcode");
  //   if (!postcode) {
  //     alert("Please enter a postcode.");
  //     return;
  //   }
  //   try {
  //     const response = await axios.post(
  //       `${API_BASE_URL}/customer/find_address/`,
  //       {
  //         postcode: postcode,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     const addressData = response.data;
  //     console.log(addressData, "addressDataaddressData");
  //     setAddress(
  //       `${addressData.street}, ${addressData.city}, ${addressData.country}`
  //     );
  //   } catch (error) {
  //     console.error("Error fetching address:", error);
  //     alert("The Given Postcode Is Incorrect!");
  //     return;
  //   }
  // };

  const [axpended, setAxpended] = useState(false);
  const handelCards = () => {
    setAxpended(!axpended);

    const cardElements = document.querySelectorAll(".cards_actions");

    console.log(axpended, "axpended");
    console.log(cardElements, "cardElements");

    cardElements.forEach((element) => {
      element.style.marginTop = axpended == true ? "0rem" : "7rem";
    });
  };
  const match1990 = useMediaQuery("(max-width:450px)");
  const checkEidth = window.innerWidth;
  useEffect(() => {
    if (checkEidth <= 450) {
      setAxpended(true);
    }
  }, [checkEidth]);

  useEffect(() => {
    fetchData(id, setFindMorCards);
  }, [id]);

  return (
    <Container maxWidth="xl">
      <div className="main_div_find">
        <div className="box_one_find">
          <div className="check_stp1">
            <p>Step 1 of 2</p>
            <h1>Your Details</h1>
            <form
              className="form_dabits"
              // action={`${API_BASE_URL}/plans/create-checkout-session/`}
              // method="POST"
              // onSubmit={handlepaymentDetail}
              onSubmit={handleSubmit}
            >
              <div>
                <label htmlFor="1">First Name*</label>
                <input
                  type="text"
                  id="1"
                  placeholder="First Name"
                  onChange={handleFirstNameChange}
                  name="first_name"
                  required
                />
              </div>
              <div>
                <label htmlFor="2">Surname*</label>
                <input
                  type="text"
                  placeholder="SurName"
                  required
                  id="2"
                  name="surname"
                  onChange={handleSurnameChange}
                />
              </div>
              <div>
                <label htmlFor="3">Email Address*</label>
                <input
                  type="email"
                  placeholder="Email Address"
                  required
                  name="email"
                  id="3"
                  onChange={handleEmailChange}
                />
              </div>
              <div>
                <label htmlFor="4">Phone Number*</label>
                <input
                  type="number"
                  placeholder="Phone Number"
                  required
                  name="phone_number"
                  id="4"
                  onChange={handlePhoneNumberChange}
                />
              </div>
              <div className="btn_dabid_div">
                <span className="span_dabid">
                  <label htmlFor="5">Post Code*</label>
                  <br />
                  <input
                    type="text"
                    placeholder="Post Code"
                    required
                    name="postcode"
                    id="4"
                    onChange={handlePostCodeChange}
                  />
                </span>
              </div>
              <div>
                <label htmlFor="6">Enter Your Address Manually*</label>
                <input
                  type="text"
                  placeholder="Enter Your Address"
                  required
                  name="address"
                  id="6"
                  value={address}
                  onChange={handleAddressChange}
                />
              </div>
              <div>
                <div className="boiler_details">
                  <h1>Boiler Details</h1>
                  <div className="debid_celaction mb-4">
                    <span className="span_dabid">
                      <label htmlFor="5">Make</label>
                      <br />
                      <select
                        className="celect_dabid form-select "
                        onChange={handleBoilermakeChange}
                      >
                        {boilerMakes.map((item, i) => (
                          <option key={i} value={item.value}>
                            {item.value}
                          </option>
                        ))}
                      </select>
                    </span>
                    <span className="span_dabid">
                      <label htmlFor="5">Model</label>
                      <br />
                      <select
                        className="celect_dabid form-select "
                        onChange={handleboiler_modelChange}
                      >
                        {boilerMakes.map((item, i) => (
                          <option key={i} value={item.value}>
                            {item.value}
                          </option>
                        ))}
                      </select>
                    </span>
                  </div>
                  <div className="ss">
                    <label htmlFor="7">Error Code</label>
                    <input
                      type="text"
                      placeholder="Type error code"
                      id="7"
                      onChange={handleboiler_ageChange}
                    />
                  </div>
                  <div className="ss">
                    <label htmlFor="9">Boiler Age</label>
                    <input
                      type="text"
                      placeholder="Type boiler age"
                      id="9"
                      onChange={handleErrorCodeChange}
                    />
                  </div>
                  <input
                    type="hidden"
                    name="csrfmiddlewaretoken"
                    value={csrfToken}
                  />
                  <input type="hidden" name="user_id" value={user_id} />
                  <input type="hidden" name="plan_id" value={id} />

                  <Button
                    type="submit"
                    variant="contained"
                    className="paymint_btn anka_tag"
                  >
                    Continue
                  </Button>
                </div>
                {/* <p className='text_p'>A member of the WeCare team will be in touch via email to confirm your booking.</p> */}
              </div>
            </form>
          </div>
        </div>
        <div
          className="box_celected_plans oneRepaiers_card_plan"
          style={{ height: axpended ? "150px" : "fit-content" }}
        >
          {axpended ? (
            <button className="icons_expended" onClick={handelCards}>
              {" "}
              <ArrowBackIosRoundedIcon />
            </button>
          ) : null}
          {findMorcards.map((item, i) => (
            <>
              <div key={i}>
                <div className="selected_plan_div">
                  <span>
                    <p>Selected Product</p>
                    <h1>{item?.title}</h1>
                    <p className="m-0">{item?.ser}</p>
                  </span>
                  <img src={item?.img} alt="icons" />
                </div>
                <div className="cards_actions mt">
                  <div className="cards_actions">
                    {item?.working.map((item, i) => (
                      <div className="working" key={i}>
                        <CheckCircleOutlineRoundedIcon className="iconmark" />
                        {item}
                      </div>
                    ))}
                  </div>
                  <div className="cards_actions">
                    {item?.notworking?.map((item, i) => (
                      <div className="notwarking" key={i}>
                        <CancelOutlinedIcon className="notwar" />
                        <span className="spanundesr">{item}</span>
                      </div>
                    ))}
                  </div>
                  <div className="view_div">
                    <div className="document_div">
                      <h1>WeCare Documents</h1>
                      <p>
                        We want to ensure that you have chosen the correct
                        product or service.
                      </p>
                      <br />
                      <p>
                        Please read the Wecare{" "}
                        <Link to="/Terms" className="term_and_Agre">
                          Terms of Service Agreement
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="month_div">
                  <h1>{item.isFixedPrice ? 'Total Price' : 'Monthly Price'}</h1>
                  <span className="d-flex align-items-baseline">
                    <h2>{item?.price}</h2>{item.isFixedPrice ? '' : 'p/m'}
                  </span>
                </div>
                <p className="desc_dabid">
                  If you choose this service, the cost is a one-off payment
                  which will be taken prior to deployment of our approved Wecare
                  engineer. This one-off payment includes all parts and labour.
                  We reserve the right to reject a repair if we aren’t able to
                  repair your boiler. In this instance we will refund your
                  payment in full.
                </p>
              </div>
              <div className="month_div">
                <h1>{item?.serv}</h1>
                <span className="d-flex align-items-baseline">
                  <h2>{item?.fee}</h2>
                </span>
              </div>
              <p className="desc_dabid">
                {item.desc1}
              </p>
              <div className="month_div">
                <h1 className="mb-3">Cancellation</h1>
              </div>
              <p className="desc_dabid">
                You are entitled to a 14-day cooling-off period, during which
                you may cancel your one-off repair. This cooling-off period
                begins on the day your one-off repair request is accepted.
              </p>
              <p className="desc_dabid">
                Please be aware that once the job has commenced, cancellation is
                no longer possible, and you will be responsible for any
                associated costs incurred.{" "}
              </p>
            </>
          ))}
          <button className="icons_expended_bot" onClick={handelCards}>
            {" "}
            <ArrowBackIosRoundedIcon />
          </button>
        </div>
      </div>
    </Container>
  );
};

export default OneOffRepair;
